enum ToastFeedbackId {
  APP = 'app-toast-feedback',
  TEAM_MEMBERS = 'team-members-toast-feedback',
}

export default ToastFeedbackId;
